import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const taggingFixed = getTagging('portability', 'fixed', client);

  const { trackView } = useTracking({
    event: ['checkout_step4.2'],
    event_label: 'landline information',
    opts: taggingFixed.opts,
    cartProduct: taggingFixed.trackingProduct,
    pageProduct: taggingFixed?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  setTrackLink(trackView);
  return null;
};

const TaggingPortabilityInfoCard = withAnimationDelay()(TaggingComponent);

export default TaggingPortabilityInfoCard;
